import { useEffect } from 'react';
import { useStore } from '@/store';
import type { StoreSlice } from '@/store';
import { buildTemplateSave } from '@/hooks';
import { persistSave } from '@/utils';

const getDraft = ({ config: c, entries: e, graphs: g, ai }: StoreSlice) => [
  e.entries,
  g.graphs,
  c.name,
  c.domain,
  c.type,
  c.templateVariant,
  c.schemaId,
  c.discardFields,
  c.preconfiguration,
  c.configSnapshot,
  c.lastTextContentHash,
  ai.suggestions,
];

const isDraftChanged = (state: StoreSlice, prev: StoreSlice) => {
  const current = getDraft(state);
  const previous = getDraft(prev);

  return current.some((value, i) => value !== previous[i]);
};

// Keeps an unsaved template  sessionStorage as draft to keep at refresh
export const usePersistDraft = (templateId: string, enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return;

    let timeout: ReturnType<typeof setTimeout> | undefined;

    const persist = () => {
      if (!timeout) return;

      clearTimeout(timeout);
      timeout = undefined;

      try {
        const save = buildTemplateSave(useStore.getState(), templateId);
        persistSave(templateId, save);
      } catch {
        // TODO
      }
    };

    const unsubscribe = useStore.subscribe((state, prev) => {
      if (!isDraftChanged(state, prev)) return;

      clearTimeout(timeout);
      timeout = setTimeout(persist, 500);
    });
    // pagehide is when page is being unloaded, so reload or closing
    window.addEventListener('pagehide', persist);

    return () => {
      unsubscribe();
      clearTimeout(timeout);
      window.removeEventListener('pagehide', persist);
    };
  }, [templateId, enabled]);
};
